const credibledColors = {
	orange: '#ed642b',
	purple: '#250c77',
	blue: '#1396ed',
} as const;

export { credibledColors };
